import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Resource } from '../../models/resources/resource.model';
import { ResourcesService } from '../../services/resources.service';
import { ToastsService } from '../../services/toasts.service';
import { Base } from '../base/base';
import { User } from '../../models/user/user.model';
import { Title } from '@angular/platform-browser';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { EventName } from '../../../environments/environment';
import { result } from 'lodash';

@Component({
  selector: 'safetydirector-top-resources',
  templateUrl: './top-resources.component.html',
  styleUrls: ['./top-resources.component.css'],
  providers: [ResourcesService]
})
export class TopResourcesComponent extends Base implements OnInit, OnDestroy, OnChanges {
  @Input() size;
  @Input() industry;
  @Input() ergonomic?;
  @Input() latest?;
  @Input() searchString: string | null = null;

  public title;

  private BusyA;
  private BusyB;

  public resources: Resource[];
  private searchStr: string | null = null;

  constructor(private resourcesService: ResourcesService, private toastsService: ToastsService,
    private titleService: Title, private eventTrackingService: EventTrackingService) {   
    super();
    this.industry = this.getIndustry();
    this.titleService.setTitle(this.basePageTitle + this.industry);
  }

  ngOnInit(): void {
    if (this.latest) {
      this.title = 'Latest Resources';
    } else {
      this.title = 'Most Popular';
    }   
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.searchStr = changes?.['searchString']?.currentValue ?? null

    if (this.latest) {
      this.getLatestResources();
    } else if (this.ergonomic) {
      this.getTopErgonomicResources();
    } else {
      this.getTopResources();
    }
  }

  public getTopResources() {
    this.BusyA = this
      .resourcesService
      .getTopResources(this.industry, this.size, this.searchStr!)
      .subscribe(result => {
        this.resources = result.Item1
      });
  }

  public getTopErgonomicResources() {
    this.BusyA = this
      .resourcesService
      .getTopErgonomicsResources(this.industry, this.size, this.searchStr!)
      .subscribe(result => {
        this.resources = result.Item1
      });
  }

  public getLatestResources() {
    this.BusyA = this
      .resourcesService
      .getResources(this.industry, this.size, undefined, undefined, this.searchStr!)
      .subscribe(result => {
        this.resources = result.Item1
      });
  }

  public downloadFile(file, fileIcon) {
    let fileName = file.blobName;
    let user: User = this.getUserDetailsFromLocalStorage();
    // Replace the file icon with a spinner, save the original icon to replace when download is complete
    let originalFileIconSrc = fileIcon.src;
    fileIcon.src = "../../assets/images/spinner.gif"

    this.BusyB = this
      .resourcesService
      .downloadFile(file, this.getIndustry(), user.policyNumber, user.emailAddress)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        // Put back the original icon
        fileIcon.src = originalFileIconSrc;
        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });
    // track download file event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': this.latest === true ? EventName.industryResourcesLatestResource : EventName.mostPopularDownloadFile,
      'FileName': fileName
    });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }
  }
}
